import React from 'react';

interface ImageComponentProps {
    src: string;
    alt: string;
    mainMedia?: boolean;
    onPopupOpen?: () => void;
}

const Image: React.FC<ImageComponentProps> = ({ src, alt, mainMedia, onPopupOpen }) => {
    const handleImageClick = () => {
        if (mainMedia && onPopupOpen) {
            onPopupOpen();
        }
    };

    return (
        <img
            src={src}
            alt={alt}
            className="media__image"
            onClick={handleImageClick}
        />
    );
};

export default Image;